"use strict";
exports.__esModule = true;
var Swiper = require('../plugin/swiper-bundle.min.js'); //引入swiper8
require("../plugin/swiper.animate1.0.3.min.js"); //引入swiper8 动画库
require("../css/layout.scss"); //引入样式
new Swiper('.indexSwiper', {
    loop: true,
    speed: 2000,
    pagination: {
        el: '.indexSwiper .swiper-pagination',
        clickable: true
    },
    on: {
        init: function () {
            swiperAnimateCache(this); //隐藏动画元素
            swiperAnimate(this); //初始化完成开始动画
        },
        slideChangeTransitionEnd: function () {
            swiperAnimate(this);
        }
    }
});
var indexMain4BgSwiper = new Swiper('.indexMain4BgSwiper', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    }
});
var indexMain4TxtSwiper = new Swiper('.indexMain4TxtSwiper', {
    slidesPerView: 5,
    direction: 'vertical',
    pagination: {
        el: '.indexMain4TxtSwiper .swiper-pagination',
        clickable: true
    },
    breakpoints: {
        992: {
            direction: 'horizontal'
        },
        768: {
            slidesPerView: 5
        }
    }
});
if ($(window).width() < 992) {
    setInterval(function () {
        if ($('.indexMain4TxtSwiper .swiper-slide.active').length > 0) {
            if ($('.indexMain4TxtSwiper .swiper-slide.active').index() == $('.indexMain4TxtSwiper .swiper-slide.active').length - 1) {
                $('.indexMain4TxtSwiper .swiper-slide.active').removeClass('active').next().addClass('active');
            }
            else {
                $('.indexMain4TxtSwiper .swiper-slide').removeClass('active');
                $('.indexMain4TxtSwiper .swiper-slide').eq(0).addClass('active');
            }
        }
        else {
            $('.indexMain4TxtSwiper .swiper-slide').eq(0).addClass('active');
        }
    }, 3000);
}
$('.index_main4 .indexMain4TxtSwiper .swiper-slide').on('mouseenter', function () {
    indexMain4BgSwiper.slideTo($(this).index(), 1000, false);
});
var windowTop = $(window).scrollTop();
// $(window).on('scroll', function () {
//     console.log("aaaaaaa",$(window).scrollTop(),windowTop)
//     if ($(window).scrollTop() >= windowTop) {
//         $('.header').css('position', 'absolute');
//     } else {
//         $('.header').css('position', 'fixed');
//     }
//     if ($(window).scrollTop() > 0) {
//         $('.header').addClass('active');
//     } else {
//         $('.header').removeClass('active');
//     }
//     windowTop = $(window).scrollTop();
// })
new Swiper('.indexMain1Swiper', {
    observer: true,
    observeParents: true,
    pagination: {
        el: '.index_main1 .mobile_box .swiper-pagination',
        clickable: true
    }
});
